import { useContext } from 'react';
import { ApplicationFormStateContext } from '@components/ApplicationFormStateProvider';

function useApplicationFormStateContext() {
  return useContext(ApplicationFormStateContext);
}

export default useApplicationFormStateContext;
